import React from "react";
import "./Franchise.scss"

import StartupCard from "./FranchiseComponents/StartupCard/StartupCard";
import { sortByOrderAscending } from "../../../../Hospitality/helper/helper";

const FranchiseStartup = ({ components }) => {

    const getComponents = (component) => {
        switch (component.ID) {
            case "Header":
                return <div className="Franchise-startup-headers">
                    {component?.Props?.content}
                    <div className="Franchise-startup-headers-border" />

                </div>
            case "startup-card-grid":
                return <div className="Franchise-startup-cardgrid">
                    {component?.Props?.cardData.map((item, key) => {
                        return (
                            <StartupCard item={item} key={key} index={(key + 1) < 10 ? ("0" + (key + 1)) : key + 1} />

                        )
                    })}

                </div>
            default:
                return <div />
        }

    }
    return (
        <div className="Franchise-startup">
            {sortByOrderAscending(components).map((component) => {
                return getComponents(component)
            })}
        </div>
    )
}
export default FranchiseStartup